import axios from "axios";

export default {
  extendSession() {
    return axios({
      method: "get",
      url: "/api/session/extend",
    });
  },
  getSession() {
    return axios({
      method: "get",
      url: "/api/session",
    });
  },
  login({ password, username }) {
    return axios({
      data: {
        password,
        username,
      },
      method: "post",
      url: "/api/login",
    });
  },
  async update(organizationId) {
    const response = await axios({
      method: "put",
      url: `/api/session/${organizationId}`,
    });
    return response.data.result;
  },
};
